import { render, staticRenderFns } from "./FilterSection.vue?vue&type=template&id=5225a0a0&"
import script from "./FilterSection.vue?vue&type=script&lang=js&"
export * from "./FilterSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports